import { useQuery } from '@apollo/client';

import { BeastMaterialListQuery } from '~/graphql';

import * as queries from '../beastMaterials.queries';

export const useBeastMaterialList = () => {
    return useQuery<BeastMaterialListQuery, {}>(queries.BeastMaterialListQuery);
};
